/** Minimum size for touch targets in the install-app UI (DE-1707 spec §5). */
export const TOUCH_TARGET = Object.freeze({minHeight: 44, minWidth: 44});
